var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(this.value)?_c('img',{staticClass:"img-thumbnail",staticStyle:{"width":"100%","height":"100%","max-width":"100%","max-height":"100%"},attrs:{"src":this.value,"id":"prv_foto"}}):_vm._e(),_c('input',{staticClass:"filestyle",attrs:{"type":"file","name":"foto","accept":"image/*"},on:{"change":_vm.previewFiles}})])
}
var staticRenderFns = []

export { render, staticRenderFns }